/*
 * MGM Gift — cadeaux popup ajoutés automatiquement au panier.
 *
 * Un "entitlement" est accordé par le popup scratch après capture email
 * (MGMGift.grant). Il est persisté en localStorage puis synchronisé avec le
 * panier : la variante cadeau est ajoutée dès que le produit principal est
 * présent, retirée s'il disparaît. Le passage à 0 € se fait via le code promo
 * Buy X Get Y, appliqué par l'API Cart AJAX une fois le cadeau au panier
 * (fallback cookie /discount/ si l'AJAX échoue).
 */
(function () {
  var STORAGE_KEY = 'mgm_gift_entitlements';
  var GIFT_PROP = '_mgm_gift';
  var syncing = null;
  var appliedCodes = {};

  function readEntitlements() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var data = raw ? JSON.parse(raw) : {};
      return data && typeof data === 'object' ? data : {};
    } catch (e) {
      return {};
    }
  }

  function writeEntitlements(data) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch (e) {}
  }

  /*
   * Applique le code en s'appuyant sur l'API Cart AJAX (champ discount de
   * /cart/update.js) : fonctionne aussi derrière le proxy de theme dev, là où
   * la route cookie /discount/ répond 401. Cette dernière reste en fallback.
   */
  function applyDiscountCode(code) {
    if (!code) return Promise.resolve();
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: code })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/update ' + r.status);
      return r.json();
    }).catch(function () {
      return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .catch(function () {});
    });
  }

  function cartAdd(entitlement) {
    var properties = {};
    properties[GIFT_PROP] = entitlement.ns;
    properties['Cadeau'] = entitlement.label || 'Offert avec votre commande';
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: Number(entitlement.variantId), quantity: 1, properties: properties }]
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/add ' + r.status);
      return r.json();
    });
  }

  function findGiftLine(cart, entitlement) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (String(it.variant_id) === String(entitlement.variantId) && it.properties && it.properties[GIFT_PROP]) {
        return it;
      }
    }
    return null;
  }

  function mainProductInCart(cart, entitlement) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].product_id) === String(entitlement.mainProductId)) {
        if (items[i].properties && items[i].properties[GIFT_PROP]) continue;
        return true;
      }
    }
    return false;
  }

  function computeOps(cart, entitlements) {
    var ops = [];
    Object.keys(entitlements).forEach(function (ns) {
      var e = entitlements[ns];
      if (!e || !e.variantId || !e.mainProductId) return;
      var giftLine = findGiftLine(cart, e);
      var mainIn = mainProductInCart(cart, e);
      if (mainIn && !giftLine && !e.declined) {
        ops.push({ type: 'add', entitlement: e });
      } else if (giftLine && !mainIn) {
        ops.push({ type: 'remove', key: giftLine.key });
      } else if (giftLine && giftLine.quantity > 1) {
        ops.push({ type: 'clamp', key: giftLine.key });
      }
    });
    return ops;
  }

  function runOps(ops) {
    var chain = Promise.resolve();
    ops.forEach(function (op) {
      chain = chain.then(function () {
        if (op.type === 'add') return cartAdd(op.entitlement);
        return MGMFunnel.changeLine(op.key, op.type === 'remove' ? 0 : 1);
      }).catch(function (e) {
        if (window.console && console.warn) console.warn('[MGMGift] op failed', op.type, e);
      });
    });
    return chain;
  }

  /*
   * Le code n'est appliqué qu'une fois la ligne cadeau réellement au panier
   * (sinon la condition Buy X Get Y n'est pas remplie), et une seule fois par
   * chargement de page.
   */
  function ensureDiscounts(cart, entitlements) {
    var chain = Promise.resolve();
    Object.keys(entitlements).forEach(function (ns) {
      var e = entitlements[ns];
      if (!e || !e.code || e.declined || appliedCodes[e.code]) return;
      if (!findGiftLine(cart, e)) return;
      appliedCodes[e.code] = true;
      chain = chain.then(function () { return applyDiscountCode(e.code); });
    });
    return chain;
  }

  /*
   * Réconcilie panier et entitlements. Résout { changed, cart } ; `cart` est
   * le panier à jour (refetch après mutation). Les appels concurrents
   * partagent la même promesse pour éviter les doubles ajouts.
   */
  function sync(cart) {
    if (syncing) return syncing;
    var entitlements = readEntitlements();
    if (!Object.keys(entitlements).length) {
      return Promise.resolve({ changed: false, cart: cart || null });
    }
    var cartPromise = cart ? Promise.resolve(cart) : MGMFunnel.cart();
    syncing = cartPromise.then(function (c) {
      var ops = computeOps(c, entitlements);
      var mutated = ops.length > 0;
      var afterOps = mutated
        ? runOps(ops).then(function () { return MGMFunnel.cart(); })
        : Promise.resolve(c);
      return afterOps.then(function (fresh) {
        return ensureDiscounts(fresh, entitlements).then(function () {
          if (mutated) {
            try {
              document.dispatchEvent(new CustomEvent('mgm:gift:synced', { detail: { cart: fresh } }));
            } catch (e) {}
          }
          return { changed: mutated, cart: fresh };
        });
      });
    }).catch(function () {
      return { changed: false, cart: cart || null };
    }).then(function (result) {
      syncing = null;
      return result;
    });
    return syncing;
  }

  function grant(opts) {
    if (!opts || !opts.ns || !opts.variantId || !opts.mainProductId) return Promise.resolve({ changed: false, cart: null });
    var entitlements = readEntitlements();
    entitlements[opts.ns] = {
      ns: String(opts.ns),
      code: String(opts.code || ''),
      variantId: String(opts.variantId),
      mainProductId: String(opts.mainProductId),
      label: String(opts.label || ''),
      declined: false,
      grantedAt: Date.now()
    };
    writeEntitlements(entitlements);
    return sync();
  }

  /* Le client a retiré son cadeau du panier : ne pas le re-ajouter. */
  function decline(ns) {
    var entitlements = readEntitlements();
    if (entitlements[ns]) {
      entitlements[ns].declined = true;
      writeEntitlements(entitlements);
    }
  }

  function isGiftItem(item) {
    return !!(item && item.properties && item.properties[GIFT_PROP]);
  }

  function giftNamespace(item) {
    return isGiftItem(item) ? String(item.properties[GIFT_PROP]) : '';
  }

  /* Total (en centimes) des lignes cadeaux, à déduire de l'affichage. */
  function giftDiscountCents(cart) {
    var sum = 0;
    ((cart && cart.items) || []).forEach(function (it) {
      if (isGiftItem(it)) {
        sum += it.final_line_price != null ? it.final_line_price : (it.line_price || 0);
      }
    });
    return sum;
  }

  window.MGMGift = {
    grant: grant,
    sync: sync,
    decline: decline,
    isGiftItem: isGiftItem,
    giftNamespace: giftNamespace,
    giftDiscountCents: giftDiscountCents
  };

  /* Le produit principal vient d'être ajouté : le cadeau suit immédiatement. */
  document.addEventListener('product:added-to-cart', function () { sync(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync(); });
  } else {
    sync();
  }
})();
